import { render } from "./SentGeoView.vue?vue&type=template&id=36dea104&ts=true"
import script from "./SentGeoView.vue?vue&type=script&lang=ts"
export * from "./SentGeoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__